import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import SearchButton from '../../components/atoms/SearchButton';
// import ESSearchButton from '../../components/atoms/ESSearchButton';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
// import CsvDownloadEsButton from '../../components/atoms/CsvDownloadEsButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getUpdateAmountHistoryList,
  downloadUpdateAmountHistoryList,
  GET_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS,
  DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS
} from '../../actions/Gochis';
import UpdateAmountHistoryTableShop from '../organisms/UpdateAmountHistoryTableShop';
import DownloadCsvDialogConfirm from '../../components/molecules/DownloadCsvDialogConfirm';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    textAlign: 'left',
    marginBottom: 10,
    fontSize: 24
  },
  mainContent: {
    padding: 15
  },
  mainPaper: {
    position: 'relative'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '25%'
  },
  button: {
    margin: '5px 5px'
  },
  buttonLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  textNoteClassicCsv: {
    fontSize: 12,
    width: 220,
    marginLeft: 'auto',
    textAlign: 'left'
  },
  textLinkCsv: {
    color: '#2196F3'
  },
  fs24: {
    fontSize: '24px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getUpdateAmountHistoryList,
          downloadUpdateAmountHistoryList
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuId', 'setMenuId', ''),
  withState('menuName', 'setMenuName', ''),
  withState('displayName', 'setDisplayName', ''),
  withState('useDateFrom', 'setUseDateFrom', ''),
  withState('useDateTo', 'setUseDateTo', ''),
  withState('editedFrom', 'setEditedFrom', ''),
  withState('editedTo', 'setEditedTo', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('updateAmountHistoryList', 'setUpdateAmountHistoryList', []),
  withState('updateAmountHistoryCount', 'setUpdateAmountHistoryCount', 0),
  withState('updateAmountHistoryOffset', 'setUpdateAmountHistoryOffset', null),
  withState('openPopupCsv', 'setOpenPopupCsv', false),
  withState('isZip', 'setIsZip', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      const searchKey = {
        menuName: props.menuName,
        displayName: props.displayName,
        useDateFrom: props.useDateFrom,
        useDateTo: props.useDateTo,
        editedFrom: props.editedFrom,
        editedTo: props.editedTo,
        menuId: props.menuId,
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);

      props.actions
        .getUpdateAmountHistoryList(searchKey)
        .then(data => {
          // props.checkSession(data);
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (data.type === GET_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS) {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
            props.setUpdateAmountHistoryList(data.payload.list);
            props.setUpdateAmountHistoryCount(data.payload.count);
            props.setUpdateAmountHistoryOffset(data.payload.offset);
          } else {
            props.setResultMessage('エラーが発生しました！');
            props.updateLoading(false);
          }
        })
        .catch(e => {
          console.log(e);
          props.updateOpenProgress(true);
          props.setResultMessage('エラーが発生しました！');
          props.updateLoading(false);
        });
      // }
      props.setPage(page);
    }
  }),
  lifecycle({
    async componentDidMount() {
      isAuthenticated(this.props);
      this.props.handleChangePage(null, 1, this.props.rowsPerPage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleChangePage,
    updateOpenDrawer,
    openTable,
    updateOpenTable,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    menuName,
    setMenuName,
    displayName,
    setDisplayName,
    useDateFrom,
    setUseDateFrom,
    useDateTo,
    setUseDateTo,
    editedFrom,
    setEditedFrom,
    editedTo,
    setEditedTo,
    menuId,
    setMenuId,
    page,
    setPage,
    setRowsPerPage,
    updateAmountHistoryList,
    setUpdateAmountHistoryList,
    updateAmountHistoryCount,
    setUpdateAmountHistoryCount,
    updateAmountHistoryOffset,
    setUpdateAmountHistoryOffset,
    history,
    openPopupCsv,
    setOpenPopupCsv,
    isZip,
    setIsZip
  }) => {
    const rowsPerPage = document.getElementById('rowsPerPage');
    let limit = 100;
    if (rowsPerPage) {
      limit = rowsPerPage.textContent;
    }

    const searchKey = {
      menuName,
      menuId,
      displayName,
      useDateFrom,
      useDateTo,
      editedFrom,
      editedTo,
      limit
    };

    const searchAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      setPage(1);
      await actions
        .getUpdateAmountHistoryList(searchKey)
        .then(data => {
          checkSession(data);
          if (data.type === GET_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS) {
            updateOpenProgress(false);
            setResultMessage('');
            updateLoading(false);
            updateOpenTable(true);
            setUpdateAmountHistoryList(data.payload.list);
            setUpdateAmountHistoryCount(data.payload.count);
            setUpdateAmountHistoryOffset(data.payload.offset);
          } else {
            setResultMessage('エラーが発生しました！');
            updateLoading(false);
            setUpdateAmountHistoryList([]);
            setUpdateAmountHistoryCount(0);
            setUpdateAmountHistoryOffset(null);
          }
        })
        .catch(() => {
          updateOpenProgress(true);
          setResultMessage('エラーが発生しました！');
          updateLoading(false);
          setUpdateAmountHistoryList([]);
          setUpdateAmountHistoryCount(0);
          setUpdateAmountHistoryOffset(null);
        });
    };

    const downloadCsvBlob = (blob, fileName, isZipP) => {
      const blobC = new Blob([blob], {
        type: isZipP ? 'application/zip' : 'text/csv'
      });
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blobC, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(blobC);
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async isZipP => {
      updateLoading(true);
      updateOpenProgress(true);
      let fileType = '';
      const params = { ...searchKey };
      if (isZipP) {
        params.isZip = 1;
        fileType = '.csv.zip';
      } else {
        params.isZip = 0;
        fileType = '.csv';
      }
      const response = await actions
        .downloadUpdateAmountHistoryList(params)
        .then(data => checkSession(data))
        .catch(() => {
          updateOpenProgress(true);
          setResultMessage(
            'ファイル容量が想定量を超えたため、ダウンロードに失敗しました。\n恐れ入りますが、期間を短く設定し直してから再度ダウンロードを実行ください。'
          );
          updateLoading(false);
        });
      if (
        response &&
        response.type === DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS
      ) {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);
        downloadCsvBlob(
          response.payload,
          `${timeStamp}_coupon_edit_history${fileType}`,
          isZipP
        );
      } else {
        updateOpenProgress(true);
        setResultMessage(
          'ファイル容量が想定量を超えたため、ダウンロードに失敗しました。\n恐れ入りますが、期間を短く設定し直してから再度ダウンロードを実行ください。'
        );
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const cancelCsvAction = () => {
      setOpenPopupCsv(false);
      setIsZip(false);
    };

    const downloadCsvAction = () => {
      setOpenPopupCsv(false);
      csvDownloadAction(isZip);
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <div className={classes.mainContent}>
          <div className={classes.pageTitileDiv}>
            <Typography color="textPrimary" className={classes.fs24}>
              {'クーポン情報管理 > 金額修正履歴'}
            </Typography>
          </div>
          <Paper className={classes.mainPaper} elevation={1}>
            <div className={classes.searchForm}>
              <div>
                <TextField
                  label="コース名"
                  placeholder="コース名"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={menuName}
                  onChange={e => {
                    setMenuName(e.target.value);
                  }}
                />
                <TextField
                  label="コースID"
                  placeholder="コースID"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={menuId}
                  onChange={e => {
                    setMenuId(e.target.value);
                  }}
                />
              </div>
              <div>
                <TextField
                  label="利用者名"
                  placeholder="利用者名"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={displayName}
                  onChange={e => {
                    setDisplayName(e.target.value);
                  }}
                />
              </div>
              <div>
                <TextField
                  label="使用日(From)"
                  type="date"
                  className={classes.textField}
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={useDateFrom}
                  onChange={e => {
                    setUseDateFrom(e.target.value);
                  }}
                  onBlur={e => {
                    if (!useDateFrom) {
                      e.target.value = '';
                      setUseDateFrom('');
                    }
                  }}
                />
                <TextField
                  label="使用日(To)"
                  type="date"
                  className={classes.textField}
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={useDateTo}
                  onChange={e => {
                    setUseDateTo(e.target.value);
                  }}
                  onBlur={e => {
                    if (!useDateTo) {
                      e.target.value = '';
                      setUseDateTo('');
                    }
                  }}
                />
                <TextField
                  label="金額修正日(From)"
                  type="date"
                  className={classes.textField}
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={editedFrom}
                  onChange={e => {
                    setEditedFrom(e.target.value);
                  }}
                  onBlur={e => {
                    if (!editedFrom) {
                      e.target.value = '';
                      setEditedFrom('');
                    }
                  }}
                />
                <TextField
                  label="金額修正日(To)"
                  type="date"
                  className={classes.textField}
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={editedTo}
                  onChange={e => {
                    setEditedTo(e.target.value);
                  }}
                  onBlur={e => {
                    if (!editedTo) {
                      e.target.value = '';
                      setEditedTo('');
                    }
                  }}
                />
              </div>
              <div className={classes.buttonLeft}>
                <SearchButton onClickAction={searchAction} />
              </div>
              <div className={classes.buttonRight}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ margin: '5px 5px' }}
                  onClick={() => {
                    history.push({
                      pathname: '/gochis_shop',
                      state: { viewClassicMode: false }
                    });
                  }}
                >
                  通常モードに戻る
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ margin: '5px 5px' }}
                  onClick={() => {
                    history.push({
                      pathname: '/gochis_shop',
                      state: { viewClassicMode: true }
                    });
                  }}
                >
                  クーポン情報管理に戻る
                </Button>
                <CsvDownloadButton
                  title="検索結果出力（CSV形式）"
                  onClickAction={() => {
                    setIsZip(false);
                    setOpenPopupCsv(true);
                  }}
                />
                <CsvDownloadButton
                  title="検索結果出力（ZIP形式）"
                  onClickAction={() => {
                    setIsZip(true);
                    setOpenPopupCsv(true);
                  }}
                />
                <div className={classes.textNoteClassicCsv}>
                  ※CSV形式でダウンロードができない場合はZIP形式をお試しください。
                  ZIP形式の説明は
                  <a
                    className={classes.textLinkCsv}
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://shop-guide.gochimeshi.com/individual/p16028/"
                  >
                    こちら
                  </a>
                </div>
              </div>
            </div>
            {openTable && (
              <UpdateAmountHistoryTableShop
                handleChangePage={handleChangePage}
                selectedPage={page}
                setRowsPerPage={setRowsPerPage}
                updateAmountHistoryList={updateAmountHistoryList}
                updateAmountHistoryCount={updateAmountHistoryCount}
                updateAmountHistoryOffset={updateAmountHistoryOffset}
              />
            )}
          </Paper>
        </div>

        <DownloadCsvDialogConfirm
          message="ダウンロード情報には個人情報が含まれますので、取扱いには十分留意してください"
          openChangeConfirm={openPopupCsv}
          updateOpenChangeConfirm={setOpenPopupCsv}
          cancelAction={cancelCsvAction}
          changeAction={downloadCsvAction}
        />

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
